<template>
    <div id="createTicket">
        <a-modal
                title="Create Ticket by Location"
                :visible="ticketVisible"
                width="65%"
                @cancel="cancel"
                style="display: flex"
        >
            <template slot="footer">
                <a-button key="submit" type="primary" @click="cancel">{{ $t('publicLang.Cancel') }}</a-button>
                <a-button key="cancel" type="primary" @click="editSave">{{ $t('publicLang.Confirm') }}</a-button>
            </template>


            <a-row type="flex" justify="start" style="margin-bottom: 10px;">
                <a-col style="margin-left: 10px; margin-right: 10px;">
                    <label>{{ $t('cycleCount.Location') }}:</label>
                    <a-input :placeholder="$t('publicLang.PleaseEnter')"  size="small" style="width: 270px;margin-left: 3px;" v-model="locationCodes"/>
                </a-col>
                <a-col>
                    <a-button type="primary" size="small" @click="search">{{ $t('publicLang.Search') }}</a-button>
                </a-col>
            </a-row>

            <a-row style="margin-bottom: 5px" type="flex" justify="end" >
                <div style="width: 100%; padding-left: 20%">
                    <a-pagination :pageSizeOptions="pageSizeOptions"
                                  :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                                  size="small"
                                  :total="pagingTotal"
                                  v-model="currentVal" :pageSize.sync="pagingSize" @change="tableChangePage"
                                  @showSizeChange="onShowSizeChange" showSizeChanger />
                </div>
            </a-row>

            <a-row>
                <div class="box">
                    <div class="left">
                        <a-divider  style="margin: 10px 0px" />
                        <template >
                            <div >
                                <a-table
                                        row-key="LOCATION_CODE"
                                        class="table"
                                        :row-selection="{ selectedRowKeys: selectedRowKeysLeft, onChange: onSelectChangeLeft }"
                                        :columns="SubmapTocolumns"
                                        :dataSource="SubmapTolistLeft"
                                        size="small"
                                        :pagination="nopagination"
                                        :locale="tabelText"
                                        :loading="tableLoadingSub"
                                />
                            </div>
                        </template>
                    </div>

                    <div class="center">
                        <a-button type="primary" size="small" @click="turnToCreate"><a-icon type="right" /> </a-button>
                        <br>
                        <a-button type="primary" size="small" @click="turnToCancel"> <a-icon type="left" /></a-button>
                    </div>

                    <div class="right">
                        <a-divider style="margin: 10px 0px" />
                        <template >
                            <div>
                                <a-table
                                        row-key="LOCATION_CODE"
                                        class="table"
                                        :row-selection="{ selectedRowKeys: selectedRowKeysRight, onChange: onSelectChangeRight }"
                                        :columns="SubmapTocolumns"
                                        :dataSource="SubmapTolistRight"
                                        size="small"
                                        :pagination="nopagination"
                                        :locale="tabelText"
                                        :loading="tableLoadingSub"
                                />
                            </div>
                        </template>
                    </div>
                </div>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import difference from 'lodash/difference';

    export default{
        data(){
            return{
                ticketVisible: false,
                locationCodes: '',
                tableData: [],
                scheaderUid: '',
                pageSizeOptions: ['10', '20', '30', '40', '100', '200', '500', '1000'],
                pagingTotal: 0, // 总数
                pagingSize: 10, // 条数
                currentVal: 1, // 页数,

                tabelText: {
                    emptyText: "No record found"
                },
                tableLoadingSub: false,
                SubmapTocolumns: [
                    {
                        title: "Location",
                        dataIndex: "LOCATION_CODE",
                        scopedSlots: { customRender: "Location" }
                    }
                ],
                nopagination: false,
                SubSlotsArray: ["Location"],
                SubmapTolistLeft: [],
                selectedRowDataLeft: [],
                selectedRowKeysLeft: [],
                selectedRowsLeft: [],


                SubmapTolistRight: [],
                selectedRowDataRight: [],
                selectedRowKeysRight: [],
                selectedRowsRight:[]
            }
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods:{
            show(scHeaderUid){
                this.ticketVisible = true
                this.scHeaderUid = scHeaderUid
                this.init()
            },
            cancel(){
                this.ticketVisible = false
            },
            init(){
                this.pageSize = 10;
                this.SubmapTolistLeft = [];
                this.SubmapTolistRight = [];
                this.selectedRowKeysLeft = [];
                this.selectedRowKeysRight = [];
                this.locationCodes = '';
                let paramsLocation = {
                    uid: '',
                    pageNum: 1,
                    pageSize: 10,
                    language: 2
                }
                paramsLocation.uid = this.scHeaderUid;
                ajax.get(api.INVENTORYCYCLEGETLEGALCREATELOCATION, paramsLocation).then(res => {
                    if(res.code == 200) {
                        this.pagingTotal = res.data.pagingTotal
                        this.SubmapTolistLeft = res.data.data
                    } else {
                        this.$customMessage.warning(res.msg)
                    }
                })
            },
            // 分页信息修改
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pageSize = pageSize;
                this.search();
            },
            // sub table 分页
            tableChangePage(current) {
                this.currentVal = current;
                this.search();
            },
            checkObjIsNotEmpty(obj) {
                if(obj==undefined||obj==null||obj=='') {
                    return false;
                } else {
                    return true;
                }
            },
            //   校验
            editSave(){
                if (this.SubmapTolistRight.length != 0) {
                    let params = new Map();
                    params.set('uid',this.scHeaderUid);
                    params.set('location',this.SubmapTolistRight);
                    params.set('language',2);
                    let valuesMapObj = Object.create(null);
                    for(let[k,v] of params) {
                        valuesMapObj[k] = v;
                    }

                    // let needOpenDialog = false;
                    let normalLocations = [];
                    let  inScDetailLocations = [];
                    let  notInScDetailLocations = [];
                    for (let index in this.SubmapTolistRight) {
                        console.info(this.SubmapTolistRight[index])
                        let locationCode = this.SubmapTolistRight[index].LOCATION_CODE;
                        let status = this.SubmapTolistRight[index].status;
                        let isAdditionalLoc = this.SubmapTolistRight[index].CYCLE_COUNT_ADDITIONAL_LOC;



                        if(this.checkObjIsNotEmpty(this.SubmapTolistRight[index].CYCLE_COUNT_ADDITIONAL_LOC) && this.SubmapTolistRight[index].CYCLE_COUNT_ADDITIONAL_LOC == 'Y' && '03' !== status) {
                            notInScDetailLocations.push(locationCode);
                        }else {
                            if ('02' == status || '03' == status){
                                if ('Y' == isAdditionalLoc || 'y' == isAdditionalLoc){
                                    inScDetailLocations.push(locationCode);
                                }else {
                                    normalLocations.push(locationCode)
                                }
                            }
                        }
                    }




                    if(normalLocations.length == 0 && inScDetailLocations.length == 0 &&  notInScDetailLocations.length == 0) {
                        // 默认流程
                        this.postINVENTORYCYCLECREATETICKET(valuesMapObj);
                    } else {

                        let titleMsg = inScDetailLocations.length == 0 &&  notInScDetailLocations.length == 0 && normalLocations.length > 0 ? this.$t('cycleCount.confirmToReCountLocation') : this.$t('cycleCount.confirmToCreateTicketForLocation');

                        let that = this;
                        this.$confirm({
                            title: this.$createElement('p', { style: {  fontSize: '18px' , margin:'0px',fontWeight: 'bold' } }, titleMsg) ,
                            content: this.$createElement('div', [
                                // 创建 notInScDetailLocations 数组的每个元素，并设置红色
                                ...notInScDetailLocations.map(location =>
                                    this.$createElement('p', { style: { color: 'red', fontSize: '14px' , margin:'0px' } }, location+'(New Out of Count)')
                                ),
                                ...inScDetailLocations.map(location =>
                                    this.$createElement('p', { style: { color: 'red', fontSize: '14px' , margin:'0px' } }, location+'(Out of Count)')
                                ),
                                // 创建 normalLocations 数组的每个元素
                                ...normalLocations.map(location =>
                                    this.$createElement('p', { style: { fontSize: '14px',margin:'0px' } }, location)
                                )
                            ]),
                            okText:  this.$t('generic.Yes'),
                            cancelText: this.$t('generic.No'),
                            onOk() {
                                that.postINVENTORYCYCLECREATETICKET(valuesMapObj);
                            },
                            onCancel() {
                                return;
                            }
                        });


                    }


                } else {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                }

            },
            postINVENTORYCYCLECREATETICKET(valuesMapObj) {
                ajax.post(api.INVENTORYCYCLECREATETICKET,valuesMapObj).then (res => {
                    if(res.code == 200) {
                        this.$message.success("success \n " + res.data.ticket);
                    } else {
                        this.$customMessage.warning(res.msg)
                    }
                    // 清空右侧选中的数据
                    this.SubmapTolistRight = [];
                    this.selectedRowDataRight = [];
                    this.selectedRowKeysRight = [];
                })
            },
            // 选中数据项
            onSelectChangeLeft(selectedRowKeys, selectedRows) {
                this.selectedRowKeysLeft = selectedRowKeys;
                this.selectedRowsLeft = selectedRows;
            },
            onSelectChangeRight(selectedRowKeys, selectedRows) {
                this.selectedRowKeysRight = selectedRowKeys;
                this.selectedRowsRight = selectedRows;
            },
            turnToCancel() {
                for(var now of this.selectedRowsRight) {
                    this.SubmapTolistLeft.push(now);
                }
                this.SubmapTolistRight = this.SubmapTolistRight.filter((item,index) => {
                    if(!this.SubmapTolistLeft.includes(item)) {
                        return true;
                    }
                })
                this.selectedRowsRight = [];
                this.selectedRowKeysRight = [];

                // 4. 对 SubmapTolistLeft 按 LOCATION_CODE 升序排序
                this.SubmapTolistLeft.sort((a, b) => {
                    return a.LOCATION_CODE.localeCompare(b.LOCATION_CODE);
                });
            },
            turnToCreate() {
                for(var now of this.selectedRowsLeft) {
                    if(now != undefined) {
                        this.SubmapTolistRight.push(now);
                    }
                }
                this.SubmapTolistLeft = this.SubmapTolistLeft.filter((item,index) => {
                    if(!this.SubmapTolistRight.includes(item)){
                        return true;
                    }
                });
                this.selectedRowsLeft = [];
                this.selectedRowKeysLeft = [];
            },
            search() {
                let paramsLocation = {
                    uid: '',
                    pageNum: 1,
                    pageSize: 10,
                    language: 2,
                    locationCodes: ''
                }
                paramsLocation.pageNum = this.currentVal;
                paramsLocation.pageSize = this.pageSize;
                paramsLocation.uid = this.scHeaderUid;
                paramsLocation.locationCodes = this.locationCodes;
                ajax.get(api.INVENTORYCYCLEGETLEGALCREATELOCATION, paramsLocation).then(res => {
                    if(res.code == 200) {
                        this.pagingTotal = res.data.pagingTotal
                        this.SubmapTolistLeft = res.data.data

                        var locationCodes = [];
                        for(var now of this.SubmapTolistRight) {
                            locationCodes.push(now.LOCATION_CODE);
                        }
                        // 过滤掉右边已经选中的
                        this.SubmapTolistLeft = this.SubmapTolistLeft.filter((item,index) => {
                            if(!locationCodes.includes(item.LOCATION_CODE)){
                                return true;
                            }
                        })
                    } else {
                        this.$customMessage.warning(res.msg);
                    }
                })

            }
        }
    }
</script>


<style scoped>
    .box {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        /* align-items: center; */
    }

    .left {
        height: 100%;
        margin-left: 0;
        width: 45%;
    }
    .right {
        height: 100%;
        width: 45%;
    }

    .center {
        width: 3%;
        display: flex;
        justify-content: center;
        /* align-items: center; */
        flex-direction: column;
    }

    .table {
        min-height: 150px;
    }
</style>